import React from 'react';

const Button = ({ href, children, className, size = 'medium', color = 'secondary', ...props }) => {
  const baseClasses = "w-fit border border-solid text-white font-display font-extralight transition-colors cursor-pointer flex items-center";

  const sizeClasses = {
    small: "text-sm px-6 py-2",
    medium: "text-xl px-8 py-3",
    large: "text-2xl px-10 py-4",
  };

  const colorSchemes = {
    primary: "bg-primary-700 border-primary-700 hover:text-primary-700 hover:bg-white",
    secondary: "bg-secondary-500 border-secondary-500 hover:text-secondary-500 hover:bg-white",
  };

  const combinedClasses = `${baseClasses} ${sizeClasses[size]} ${colorSchemes[color]} ${className || ''}`;

  if (href) {
    return (
      <a href={href} className={combinedClasses} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button className={combinedClasses} {...props}>
      {children}
    </button>
  );
};

export default Button;